import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { extend } from 'lodash';

@Component({
  selector: 'app-deal-data-overrides-dialog',
  templateUrl: './deal-data-overrides-dialog.component.html',
  styleUrls: ['./deal-data-overrides-dialog.component.scss']
})
export class DealDataOverridesDialogComponent implements OnInit {

  model = {};

  formlyFields: FormlyFieldConfig[] = [
    {
      type: 'intl-phone',
      fieldGroup: [
        {
          type: 'country-code-select',
          key: 'phoneCountryCode',
          className: 'formly-sub-column',
        },
        {
          type: 'phone-phone',
          key: 'phone',
          wrappers: [],
          className: 'formly-sub-column-2',
          props: {
            label: 'Primary Phone',
            required: true,
          },
        },
      ]
    },
    {
      key: 'email',
      type: 'input',
      props: {
        type: 'email',
        label: 'Email',
        required: true,
        pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
      }
    },
    {
      key: 'reason',
      type: 'input',
      defaultValue: 'Honeypot',
      props: {
        label: 'Reason',
        required: true,
      }
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    extend(this.model, this.data.contact_overrides);
  }

}
